import React, { Component } from 'react';
import Pagination from 'react-bootstrap/Pagination'
import { connect } from "react-redux";
import { setSelectedPaginationPage, pageinateSearch } from "../../../redux/actions/paginatorActions";
import { LOADING_STATUES } from "../../constants/constants";
import { spinnerIconGray } from "../../../img/font_awesome/font_awesome"
import Loading from '../modal/Loading';

const mapStateToProps = state => {
	return {
		searchHistory: state.searchHistoryReducer.searchHistoryList[0],
      searchResultsSort: state.searchResultsSortReducer,
      tableLoading: state.searchResultsTableLoadingReducer,
      searchPaginationVisitedLinks: state.searchResultsPageVisitedReducer
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		setSelectedPaginationPage: (componentName, activePageNumber) => dispatch(setSelectedPaginationPage(componentName, activePageNumber)),
      pageinateSearch: (activePageNumber, sort, url, criteria, callback) => dispatch(pageinateSearch(activePageNumber, sort, url, criteria, callback))
	}
}

class SearchPaginator extends Component {
  
   state = {
      startingPageNumber: 1,  // current starting pagination number
      activePageNumber: 1, // currently selected page number
      loadingStatus: ""
   }

   showLoading = () => {
      if (this.state.loadingStatus === "") {
        this.setState({
          loadingStatus: LOADING_STATUES.LOADING
        })
        return true;
      } 
      return false;
    }
  
    hideLoading = (status) => {
      if (status === 'ERROR') {
        this.setState({
          loadingStatus: ""
        })
      } else {
        this.setState({
          loadingStatus: ""
        })
      }
    }

   handlePageClick = (event) => {
      event.preventDefault();

      let newActivePageNumber = Number(event.target.id);
      this.setState({
         activePageNumber: newActivePageNumber,
         loadingStatus: ""
      })

      if (this.showLoading() === true) {
         this.props.pageinateSearch(newActivePageNumber, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson, this.hideLoading) ;
      }
   }

   handleFirstPageClick = (event) => {
      event.preventDefault();
   
      this.setState({
         startingPageNumber: 1,
         activePageNumber: 1,
         loadingStatus: ""
      })
      
      if (this.showLoading() === true) {
         this.props.pageinateSearch(1, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson, this.hideLoading) ;
      }
   }

   handleForwardOnePageClick = (event) => {
      event.preventDefault();
      let newActivePageNumber = this.state.activePageNumber + 1; // move forward 1 page
      if (newActivePageNumber > this.props.numberOfPages) { // make sure it stays within the upper bound
         newActivePageNumber = this.props.numberOfPages;
      }

      let newStartingPageNumber = this.state.startingPageNumber;
      let endingPageNumber = this.state.startingPageNumber + this.props.numberOfVisibleRecords - 1;
      if (newActivePageNumber > endingPageNumber) { // if the active page is not in view, scroll forward
         newStartingPageNumber = newActivePageNumber - this.props.numberOfVisibleRecords + 1;
      }
      
      this.setState({
         startingPageNumber: newStartingPageNumber,
         activePageNumber: newActivePageNumber,
         loadingStatus: ""
      })
      
      if (this.showLoading() === true) {
         this.props.pageinateSearch(newActivePageNumber, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson,   this.hideLoading) ;
      }
   }
   

   handleBackwardOnePageClick = (event) => {
      event.preventDefault();
      let newActivePageNumber = this.state.activePageNumber - 1; // move backward 1 page
      if (newActivePageNumber < 1) { // make sure it stays within the lower bound
         newActivePageNumber = 1;
      }

      let newStartingPageNumber = this.state.startingPageNumber;
      if (newActivePageNumber < newStartingPageNumber) { // if the active page is not in view, scroll backward
         newStartingPageNumber = newActivePageNumber;
      }

      if (newStartingPageNumber < 1) { // make sure it stays within the lower bound
         newStartingPageNumber = 1;
      }
      
      this.setState({
         startingPageNumber: newStartingPageNumber,
         activePageNumber: newActivePageNumber,
         loadingStatus: ""
      })
      
      if (this.showLoading() === true) {
        this.props.pageinateSearch(newActivePageNumber, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson,   this.hideLoading) ;
      }
}

   handleForwardTenPagesClick = (event) => {
      event.preventDefault();
      let newActivePageNumber = this.state.activePageNumber + 10; // move forward 10 pages
      if (newActivePageNumber > this.props.numberOfPages) { // make sure it stays within the upper bound
         newActivePageNumber = this.props.numberOfPages;
      }

      let newStartingPageNumber = this.state.startingPageNumber;
      let endingPageNumber = newStartingPageNumber + this.props.numberOfVisibleRecords - 1;
      while (newActivePageNumber > endingPageNumber) { // while the active page is not visible, scroll forward until visible
         newStartingPageNumber += this.props.numberOfVisibleRecords;
         endingPageNumber = newStartingPageNumber + this.props.numberOfVisibleRecords - 1;
      }

      if (newStartingPageNumber > this.props.numberOfPages - this.props.numberOfVisibleRecords + 1) { // make sure it stays within the upper bound
         newStartingPageNumber = this.props.numberOfPages - this.props.numberOfVisibleRecords + 1;
      }
   
      this.setState({
         startingPageNumber: newStartingPageNumber,
         activePageNumber: newActivePageNumber,
         loadingStatus: ""
      })
      
      if (this.showLoading() === true) {
         this.props.pageinateSearch(newActivePageNumber, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson, this.hideLoading) ;
      }
   }

   handleBackwardTenPagesClick = (event) => {
      event.preventDefault();
      let newActivePageNumber = this.state.activePageNumber - 10; // move backward 10 pages
      if (newActivePageNumber < 1) { // make sure it stays within the lower bound
         newActivePageNumber = 1;
      }

      let newStartingPageNumber = this.state.startingPageNumber;
      while (newActivePageNumber < newStartingPageNumber) { // while the active page is not visible, scroll backward until visible
         newStartingPageNumber -= this.props.numberOfVisibleRecords;
      }

      if (newStartingPageNumber < 1) { // make sure it stays within the lower bound
         newStartingPageNumber = 1;
      }
      
      this.setState({
         startingPageNumber: newStartingPageNumber,
         activePageNumber: newActivePageNumber,
         loadingStatus: ""
      })
      
      if (this.showLoading() === true) {
         this.props.pageinateSearch(newActivePageNumber, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson, this.hideLoading) ;
      }
   }
   handleLastPageClick = (event) => {
      event.preventDefault();
      let newStartingPageNumber = this.props.numberOfPages - this.props.numberOfVisibleRecords + 1;
      this.setState({
         startingPageNumber: newStartingPageNumber,
         activePageNumber: this.props.numberOfPages,
         loadingStatus: ""
      })

      if (this.showLoading() === true) {
         this.props.pageinateSearch(this.props.numberOfPages, this.props.searchResultsSort, this.props.searchHistory.link, this.props.searchHistory.criteriaJson, this.hideLoading) ;
      }
   }

	componentDidMount() {
      this.setState({
         startingPageNumber: 1,
         activePageNumber: 1,
         loadingStatus: ""
      });

      this.props.setSelectedPaginationPage(this.props.componentName, 1);
   }

   render() {

      let endingNumber = this.state.startingPageNumber + this.props.numberOfVisibleRecords;
      if (this.props.numberOfPages < this.props.numberOfVisibleRecords) {
         endingNumber = this.state.startingPageNumber + this.props.numberOfPages;
      }     

      let paginationItems = [];
      for (let number = this.state.startingPageNumber; number < endingNumber; number++) {

         let paginationItem = <Pagination.Item key={number} id={number}  style={{ borderTop: '3px solid darkGray', borderBottom: '3px solid darkGray' }} onClick={this.handlePageClick} active={number === this.state.activePageNumber}>{number}</Pagination.Item>

         if (number !== this.state.activePageNumber && this.props.searchPaginationVisitedLinks.includes(number)) {
            paginationItem = <Pagination.Item key={number} id={number}  style={{ borderTop: '3px solid darkGray', borderBottom: '3px solid darkGray' }} className='paginationItemVisitedLink' onClick={this.handlePageClick} active={number === this.state.activePageNumber}>{number}</Pagination.Item>
         }

         paginationItems.push(
            paginationItem
         );
      }
      
      let firstPagePageLink = <></>
      let lastPagePageLink = <></>

      // round corners
      let backwardOnePagePageLink = <Pagination.Item key="backward1" id="backward1" style={{ border: '3px solid darkGray', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px' }} onClick={this.handleBackwardOnePageClick}>Prev</Pagination.Item>
      let forwardOnePagePageLink = <Pagination.Item key="forward1" id="forward1" style={{ border: '3px solid darkGray', borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }} onClick={this.handleForwardOnePageClick}>Next</Pagination.Item>
      
      let backwardTenPagesPageLink = <></>
      let forwardTenPagesPageLink = <></>

      if (this.props.numberOfPages > this.props.numberOfVisibleRecords) {
         // round corners
         firstPagePageLink = <Pagination.Item key="first" id="first" style={{ borderTop: '3px solid darkGray', borderBottom: '3px solid darkGray', borderLeft: '3px solid darkGray', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px' }} onClick={this.handleFirstPageClick}>First</Pagination.Item>
         lastPagePageLink = <Pagination.Item key="last" id="last" style={{ borderTop: '3px solid darkGray', borderBottom: '3px solid darkGray', borderRight: '3px solid darkGray', borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }} onClick={this.handleLastPageClick}>Last</Pagination.Item>
         
         // change to sharp corners, as they are no longer the rightmost and leftmost page links.
         backwardOnePagePageLink = <Pagination.Item key="backward1" id="backward1" style={{ border: '3px solid darkGray' }} onClick={this.handleBackwardOnePageClick}>Prev</Pagination.Item>
         forwardOnePagePageLink = <Pagination.Item key="forward1" id="forward1" style={{ border: '3px solid darkGray' }} onClick={this.handleForwardOnePageClick}>Next</Pagination.Item>
   
         if (this.props.numberOfPages > 30) { // show the "move 10 pages" links only if the number of pages is greater than 30
            backwardTenPagesPageLink = <Pagination.Item key="backward10" id="backward10" style={{ borderTop: '3px solid darkGray', borderBottom: '3px solid darkGray', borderLeft: '3px solid darkGray' }} onClick={this.handleBackwardTenPagesClick}>-10</Pagination.Item>
            forwardTenPagesPageLink = <Pagination.Item key="forward10" id="forward10" style={{ borderTop: '3px solid darkGray', borderBottom: '3px solid darkGray', borderRight: '3px solid darkGray' }} onClick={this.handleForwardTenPagesClick}>+10</Pagination.Item>
         }
      }
      
      return (
         <>
            {  this.props.tableLoading === true  &&  
                  <span>{spinnerIconGray}</span>
            }
            {  this.props.tableLoading !== true && this.props.numberOfPages > 1 &&  // show pagination only if there's more than 1 page
               <Pagination size="sm">
                  {firstPagePageLink}
                  {backwardTenPagesPageLink}
                  {backwardOnePagePageLink}
                  {paginationItems}
                  {forwardOnePagePageLink}
                  {forwardTenPagesPageLink}
                  {lastPagePageLink}
               </Pagination>
            }
            <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
         </>
      )
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(SearchPaginator);